export const FETCH_LIST_INTEGRATION = 'FETCH_LIST_INTEGRATION';
export const SAVE_INTEGRATION = 'SAVE_INTEGRATION';
export const FETCH_INTEGRATION_BY_ID = 'FETCH_INTEGRATION_BY_ID';
export const DELETE_INTEGRATION = 'DELETE_INTEGRATION';